import React, { Component } from "react";
import { Link } from "react-router-dom";

class CopyRight extends Component {
  render() {
    const { isTr } = this.props;
    const currentYear = new Date().getFullYear();
    return (
      <div className="ltn__copyright-area ltn__copyright-2 section-bg-7  plr--5">
        <div className="container-fluid ltn__border-top-2">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="ltn__copyright-design clearfix">
                <p>
                  {isTr ? "Tüm Hakları Saklıdır" : "All Rights Reserved"} ©
                  SAFKAR <span className="current-year">{currentYear}</span>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-12 align-self-center">
              <div className="ltn__copyright-menu text-end">
                <ul className="go-top">
                  <li>
                    <a
                      href="https://e-sirket.mkk.com.tr/?page=company&company=24369"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {isTr
                        ? "Bilgi Toplumu Hizmetleri"
                        : "Information Society Services"}
                    </a>
                  </li>
                  <li>
                    <Link to="/sikca-sorulanlar-ve-bilgiler">
                      {isTr ? "Aydınlatma Metni" : "Clarification Text"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/sikca-sorulanlar-ve-bilgiler">
                      {isTr ? "KVKK" : "The Law on Proctetion of Personal Data"}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CopyRight;
